exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"blue-050": "#f3fcff",
	"blue-100": "#ccf1ff",
	"blue-300": "#82ddff",
	"blue-500": "#00baff",
	"blue-700": "#079bd3",
	"blue-900": "#0780ae",
	"blue-s500": "#3ae6ff",
	"blue-s700": "#00d2f1",
	"blue-s900": "#007cff",
	"red-050": "#fff3f3",
	"red-100": "#ffe0e0",
	"red-300": "#ff9492",
	"red-500": "#ff6562",
	"red-700": "#d35755",
	"red-900": "#b64341",
	"red-s500": "#ff3a3a",
	"green-050": "#f3fff5",
	"green-100": "#ccf6e9",
	"green-300": "#78e2c1",
	"green-500": "#00d494",
	"green-700": "#07b07d",
	"green-900": "#078a63",
	"green-s500": "#3affd9",
	"yellow-050": "#fffceb",
	"yellow-100": "#fff5a5",
	"yellow-300": "#ffe388",
	"yellow-500": "#ffd757",
	"yellow-700": "#ffa91f",
	"yellow-900": "#e8940e",
	"yellow-s500": "#fffd3a",
	"smoke-050": "#f5f8fa",
	"smoke-100": "#d8ddeb",
	"smoke-300": "#b3becd",
	"smoke-500": "#9fabbb",
	"smoke-700": "#757d8c",
	"smoke-900": "#2e3545",
	"storm-050": "#f3fcff",
	"storm-100": "#c5d3e0",
	"storm-300": "#a0b1c5",
	"storm-500": "#8b9fb7",
	"storm-700": "#6c88a2",
	"storm-900": "#577188",
	"root-000": "#fff",
	"root-100": "#c8c8c8",
	"root-300": "#a4a4a4",
	"root-500": "#7d7d7d",
	"root-700": "#5f5f5f",
	"root-900": "#222",
	"lighter": "#d8ddeb",
	"lightest": "#f3fcff",
	"white": "#fff",
	"menu": "#fff",
	"submenu": "#f5f8fa",
	"warning": "#ffd757",
	"success": "#00d494",
	"danger": "#ff6562",
	"info": "#8b9fb7",
	"active": "#00baff",
	"cool-sky": "#00baff,#3ae6ff",
	"light-tree": "#00baff,#3affd9",
	"moonlight": "#2e3545,#577188",
	"white-sky": "#fff,#f5f8fa",
	"sanches": "#00baff,#007cff"
};